angular.module('List').controller('ListsController', [
    '$scope',
    '$location',
    function ($scope, $location) {
        $scope.$location = $location;
}]);
